import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { JobService } from '../job-service/job.service';
import { EEOCModel } from '../job-service/models/eeoc-model';

@Injectable({
  providedIn: 'root'
})
export class ApplyVoluntaryIdentificationResolver implements Resolve<EEOCModel> {

  constructor(private service: JobService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<EEOCModel> {
    return this.service.getEEOCForm(
      route.parent.params['jobId'],
      +localStorage.getItem('applicationId'),
      sessionStorage.getItem('completeApplicationPartRequestId'));
  }
}
